import React, { useState } from 'react';
import { string, bool, func, array } from 'prop-types';
import { get, filter, head } from 'lodash';
import { FormikSelect, Loading, FormSelect } from '..';
import { GetSalesChannels } from '../../graphql';
import { salesChannelKind } from '../../../../src/utils/misc';

const FormikInputSalesChannelKind = ({
    allSalesChannels,
    optionValueProp = 'id',
    native,
    value,
    onChange,
    multiple,
    allSelected,
    defaultValue,
    aditionalOptions,
    salesChannel,
    ...props
}) => {
    const initialSalesChannelValue = {
        value: 'todos',
        label: 'Todos'
    };

    const [internalValue, setInternalValue] = useState(
        initialSalesChannelValue
    );
    return (
        <GetSalesChannels allSalesChannels={allSalesChannels}>
            {({ data, loading }) => {
                const options = [ { value: 'todos', label: 'Todos' }, ...salesChannelKind(data) ];

                return (
                    <Loading loading={loading}>
                        {native ? (
                            <FormSelect
                                {...props}
                                onChange={({ value }) => {
                                    onChange({
                                        value,
                                        data: head(
                                            filter(
                                                data,
                                                ({ id }) =>
                                                    get(value, 'value') === id
                                            )
                                        )
                                    });
                                    setInternalValue(value);
                                }}
                                showArrow
                                mode='multiple'
                                optionFilterProp='name'
                                options={[...options, ...aditionalOptions]}
                                value={internalValue}
                                allSelected={allSelected}
                                multiple={multiple}
                            />
                        ) : (
                            <FormikSelect
                                {...props}
                                onChange={onChange}
                                showArrow
                                mode='multiple'
                                optionFilterProp='name'
                                options={options}
                                multiple={multiple}
                                allSelected={allSelected}
                            />
                        )}
                    </Loading>
                );
            }}
        </GetSalesChannels>
    );
};

FormikInputSalesChannelKind.defaultProps = {
    disabled: false,
    allSalesChannels: false,
    optionValueProp: 'id',
    aditionalOptions: [],
    onChange: () => {}
};

FormikInputSalesChannelKind.propTypes = {
    disabled: bool,
    allSalesChannels: bool,
    optionValueProp: string,
    onChange: func,
    native: bool,
    value: string,
    multiple: bool,
    allSelected: bool,
    defaultValue: string,
    aditionalOptions: array,
    salesChannel: string
};

export default FormikInputSalesChannelKind;
